import type { ReactNode } from "react";
import styles from "./NewRequestDialog.module.scss";

interface IDialogFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitDisabled: boolean;
  submitLabel: string;
  submitText: string;
}

export function DialogFooter({
  onCancel,
  onSubmit,
  isSubmitDisabled,
  submitLabel,
  submitText,
}: IDialogFooterProps): ReactNode {
  return (
    <div className={styles.footer}>
      <button
        type="button"
        className={`${styles.submitButton} ${!isSubmitDisabled ? styles.submitButtonEnabled : ""}`}
        disabled={isSubmitDisabled}
        onClick={onSubmit}
        aria-label={submitLabel}
      >
        {submitText}
      </button>
      <button
        type="button"
        className={styles.cancelButton}
        onClick={onCancel}
        aria-label="Cancel"
      >
        Cancel
      </button>
    </div>
  );
}
